import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CrossReference, CrossOpinionEnum, User } from '../../../types/types';

export interface TypeCellRendererComponentParams {
  crossReference: CrossReference;
  userAccount: User;
}

@Component({
    template: `
    <div class="d-flex justify-content-between">
      <span>
        <!-- Cross status - e.g. "not crossed", "crossed" -->
        <div
          class="{{ crossTypeDesc.color }} custom-line-height-cell"
          data-test-selector="cross-type-desc"
        >
          {{ crossTypeDesc.desc }}
        </div>
        <!-- Seller name -->
        <div
          class="cell-wrap-text text-truncate custom-line-height-cell"
          data-test-selector="cross-type-desc-org-name"
        >
          {{ createdBy }} <br />
          {{
            crossReference.sourceTypes &&
            crossReference.gpoOpinion?.opinion !== CrossOpinionEnum.DISPUTE
              ? crossReference.sourceTypes
                  .sort()
                  .join(' | ')
                  .replace('Attribution', 'Attribute')
              : ''
          }}
        </div>
      </span>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TypeCellRendererComponent implements ICellRendererAngularComp {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  CrossOpinionEnum = CrossOpinionEnum;
  crossReference!: CrossReference;
  crossTypeDesc!: { desc: string; color: string };
  createdBy!: string;

  agInit({ crossReference, userAccount }: CustomParams): void {
    this.crossReference = crossReference;
    this.crossTypeDesc = TypeCellRendererComponent.getCrossTypeDesc(
      crossReference?.crossReferenceDescription,
    );
    this.createdBy = this.getCreatedBy(crossReference, userAccount);
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }

  private getCreatedBy(crossReference: CrossReference, userAccount: User) {
    return userAccount.isBuyer &&
      crossReference?.createdByOrgType != 'GPO' &&
      crossReference?.createdByOrg?.name !==
        crossReference?.toProduct?.sysSeller?.name
      ? crossReference?.createdByOrg?.name || ''
      : '';
  }

  static getCrossTypeDesc(crossTypeDesc: string) {
    if (crossTypeDesc) {
      return { desc: crossTypeDesc, color: '' };
    } else {
      return { desc: 'Not Crossed', color: 'text-warning' };
    }
  }
}

interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    TypeCellRendererComponentParams {}
